import env from '@/env'

const DASHBOARD_SECTIONS = {
    CACHED_DATA_SERVICE: 'CACHED_DATA_SERVICE',
    USE_DASHBOARD_DATA: 'USE_DASHBOARD_DATA',
    USE_ENTITIES_DATA: 'USE_ENTITIES_DATA',
    MAIN_DATA_LOAD: 'MAIN_DATA_LOAD',
} as const

export type DashboardSection = typeof DASHBOARD_SECTIONS[keyof typeof DASHBOARD_SECTIONS]

const SECTIONS_COLORS_MAP: Record<DashboardSection, string> = {
    [DASHBOARD_SECTIONS.CACHED_DATA_SERVICE]: '#56ffd2',
    [DASHBOARD_SECTIONS.USE_DASHBOARD_DATA]: '#59ff59',
    [DASHBOARD_SECTIONS.USE_ENTITIES_DATA]: '#5757ff',
    [DASHBOARD_SECTIONS.MAIN_DATA_LOAD]: '#f457ff',
}

function isDashboardSection (section: string): section is DashboardSection {
    return section in DASHBOARD_SECTIONS
}

class Logger {
    private sectionsToLog: Array<DashboardSection> = []

    constructor () {
        this.sectionsToLog = env.VITE_LOGGED_SECTIONS.filter(isDashboardSection)
    }

    public makeSectionLogger (section: DashboardSection) {
        return {
            log: (...args: Array<unknown>) => {
                if (this.sectionsToLog.includes(section)) {
                    console.log(`%c[--- ${section} ---]`, `color: ${SECTIONS_COLORS_MAP[section]}`, ...args)
                }
            },
            time: (label: string) => {
                if (this.sectionsToLog.includes(section)) {
                    console.group()
                    console.log(`%c[--- ${section} ---]`, `color: ${SECTIONS_COLORS_MAP[section]}`, label)
                    console.time(label)
                    console.groupEnd()
                }
            },
            timeEnd: (label: string) => {
                if (this.sectionsToLog.includes(section)) {
                    console.group()
                    console.log(`%c[--- ${section} ---]`, `color: ${SECTIONS_COLORS_MAP[section]}`, label)
                    console.timeEnd(label)
                    console.groupEnd()
                }
            }
        }
    }
}

export default new Logger()
